// React
import React, { useState } from "react";

// Utilities
// import FloatingLabelInput from "react-floating-label-input";
import toast from "react-hot-toast";

// Handlers
// import { handleInput, handleKeyPress } from "../../../../Others/eventHandlers";
import Input from "../../../../Others/Input";

// Request
import { requestOtp } from "../../../../Request/LoginRequests";

/**
 * Login popup
 * @param {String} phn Phone no. passed from top level component
 * @param {React.SetStateAction} setPhn set phone no.
 * @param {React.SetStateAction} setState set state: login, verify or sign up
 * @returns {React.FunctionComponent}
 */
export default function Login({ phn, setPhn, setState }) {
  const [load, setLoad] = useState(false);

  //   Request an otp
  function handleSendOtp() {
    setLoad(true);
    localStorage.setItem('phn', phn);
    requestOtp(phn)
      .then(() => {
        toast.success("OTP sent");
        document.getElementById("cartVerifySpan").click();
        setState("cartVerifySpan");
      })
      .catch((err) => toast.error(err))
      .finally(() => setLoad(false));
  }

  return (
    <div
      className="offcanvas offcanvas-bottom bg-tr h-auto"
      tabIndex="-1"
      id="cartLogin"
    >
      {/* Phone no input */}
      <div className="p-4 text-light round-top bg-orange py-2 fw-bold fs-3">
        <span className="bi bi-person-circle fs-1 me-2"></span>
        <span className="fs-3">Login</span>
      </div>
      <div className="px-4 py-2 bg-white">
        <div className="pt-2 mt-3">
          <Input
            label="Mobile No."
            placeholder="Enter 10-digit Mobile No."
            value={phn}
            style={{ pb: 0.5 }}
            fontsize={20}
            dotPrecision={0}
            isAllowed={({ value }) =>
              (value > 5 && value < Math.pow(10, 10)) || value === ""
            }
            onChange={(e) => setPhn(e.target.value)}
          />
        </div>
        <br />
        <button
          className="btn-cnf btn-orange w-100 fs-3 py-1"
          disabled={load || !/^[6-9]{1}[0-9]{9}$/.test(phn)}
          onClick={handleSendOtp}
        >
          Send OTP
        </button>
      </div>
    </div>
  );
}
